export const setFilterData = data => ({
  type: 'SET_PARTY_FILTERS',
  data,
});

export const setFilterFlag = data => ({
  type: 'SET_PARTY_FILTER_FLAG',
  data,
});
